import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/dice-roller/pages/CalculatorPage";

export const Route = createFileRoute("/dice-roller")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/dice-roller",
      title: m.dice_meta_title(),
      description: m.dice_meta_description(),
      toolName: m.dice_tool_name(),
      faqs: [
        { q: m.dice_faq_q1(), a: m.dice_faq_a1() },
        { q: m.dice_faq_q2(), a: m.dice_faq_a2() },
        { q: m.dice_faq_q3(), a: m.dice_faq_a3() },
        { q: m.dice_faq_q4(), a: m.dice_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
